webpackJsonp([16],{

/***/ 1003:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__(3);
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./src/utils/default.js
var utils_default = __webpack_require__(35);

// EXTERNAL MODULE: ./src/mixins/pagination.js
var pagination = __webpack_require__(115);

// EXTERNAL MODULE: ./src/components/formatters/index.js + 12 modules
var formatters = __webpack_require__(48);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/TransferTable.vue




/* harmony default export */ var TransferTable = ({
  components: {
    DateFormatter: formatters["a" /* Date */],
    Price: formatters["d" /* Price */]
  },
  mixins: [Object(pagination["a" /* default */])('skiliko/transfers')],
  data: function data() {
    return {
      filter: {
        page: this.page
      }
    };
  },

  computed: {
    transferData: function transferData() {
      return this.transfers.map(function (e) {
        return {
          date: new Date((e.execution_date ? e.execution_date : e.creation_date) * 1000),
          status: e.status || 'CREATED',
          amount: e.debited_funds ? e.debited_funds.Amount : 0
        };
      });
    },
    headers: function headers() {
      return [{ text: this.$t('transfertable.header.date'), left: true, sortable: false }, { text: this.$t('transfertable.header.status'), left: true, sortable: false }, { text: this.$t('transfertable.header.amount'), left: false, sortable: false }];
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09597ee5","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TransferTable.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.transferData,"loading":_vm.loading,"pagination":_vm.filter,"total-items":_vm.pagination.total,"rows-per-page-items":[_vm.pagination.perPage],"no-data-text":_vm.$t('transfertable.noDataText'),"no-results-text":_vm.$t('transfertable.noResultsText'),"rows-per-page-text":_vm.$t('transfertable.rowsPerPageText'),"custom-sort":function (a) { return a; },"hide-actions":""},on:{"update:pagination":function($event){_vm.filter=$event}},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_c('date-formatter',{attrs:{"value":props.item.date}})],1),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.$t(("transfertable.status." + (props.item.status)))))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_c('price',{attrs:{"value":props.item.amount}})],1)]}}])}),_vm._v(" "),_c('div',{staticClass:"text-xs-center pt-3 pb-3"},[_c('v-pagination',{attrs:{"disabled":_vm.loading,"value":_vm.filter.page,"length":Math.ceil(_vm.pagination.total / _vm.pagination.perPage)},on:{"input":function (value) { return _vm.changePage(value); }}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_TransferTable = (esExports);
// CONCATENATED MODULE: ./src/components/TransferTable.vue
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  TransferTable,
  components_TransferTable,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_TransferTable = (Component.exports);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__(7);

// EXTERNAL MODULE: ./src/components/Stat.vue + 2 modules
var Stat = __webpack_require__(751);

// EXTERNAL MODULE: ./src/components/inputs/index.js + 75 modules
var inputs = __webpack_require__(170);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Transfer.vue





/* harmony default export */ var Transfer = ({
  components: {
    PriceInput: inputs["p" /* PriceInput */]
  },
  props: {
    maxAmount: {
      type: Number,
      required: true
    },
    currency: {
      type: String,
      required: true
    }
  },
  data: function data() {
    var max = Math.min(this.maxAmount, 250000);
    return {
      max: max,
      reference: '',
      amount: max
    };
  },

  computed: Object(vuex_esm["c" /* mapGetters */])({
    bank: 'skiliko/bank/bank',
    loading: 'skiliko/bank/isLoading',
    loadingWallet: 'skiliko/wallets/isLoading'
  }),
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])({
    fetchBank: 'skiliko/bank/fetchBank',
    _transfer: 'skiliko/wallets/transfer'
  }), {
    transfer: function transfer() {
      var _this = this;

      this._transfer({
        amount: this.amount,
        currency: this.currency,
        reference: this.reference
      }).then(function (_) {
        return _this.$emit('transferDone');
      });
    }
  }),
  mounted: function mounted() {
    this.fetchBank();
  },
  destroyed: function destroyed() {
    this.modal = false;
    this.$parent.removeOverlay();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49c60b2a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Transfer.vue
var Transfer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-title',[_vm._v(_vm._s(_vm.$t('transfer.title')))]),_vm._v(" "),(_vm.bank.active)?[(!_vm.loading)?_c('v-card-text',[_c('p',[_vm._v(_vm._s(_vm.$t('transfer.text', _vm.bank)))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('price-input',{attrs:{"config":{
          type: 'number',
          min: 0,
          max: _vm.max,
          required: true,
          hint: _vm.$t('transfer.hints.amount'),
          label: _vm.$t('transfer.labels.amount'),
        }},model:{value:(_vm.amount),callback:function ($$v) {_vm.amount=$$v},expression:"amount"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":_vm.$t('transfer.labels.reference'),"counter":"","max":"12"},model:{value:(_vm.reference),callback:function ($$v) {_vm.reference=$$v},expression:"reference"}})],1):_vm._e(),_vm._v(" "),_c('v-card-row',{attrs:{"actions":""}},[_c('v-btn',{attrs:{"disabled":_vm.amount <= 0,"loading":_vm.loading || _vm.loadingWallet,"block":"","primary":"","light":""},nativeOn:{"click":function($event){$event.stopPropagation();return _vm.transfer()}}},[_vm._v("\n        "+_vm._s(_vm.$t('transfer.submit'))+"\n      ")])],1)]:[_c('v-card-text',[_c('p',[_vm._v(_vm._s(_vm.$t('transfer.missingText')))])]),_vm._v(" "),_c('v-card-row',{attrs:{"actions":""}},[_c('v-btn',{attrs:{"router":"","href":{ name: 'Account', params: { tab: 'bank' } },"loading":_vm.loading || _vm.loadingWallet,"primary":"","block":"","light":""}},[_vm._v("\n        "+_vm._s(_vm.$t('transfer.addBank'))+"\n      ")])],1)]],2)}
var Transfer_staticRenderFns = []
var Transfer_esExports = { render: Transfer_render, staticRenderFns: Transfer_staticRenderFns }
/* harmony default export */ var components_Transfer = (Transfer_esExports);
// CONCATENATED MODULE: ./src/components/Transfer.vue
var Transfer_normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var Transfer___vue_template_functional__ = false
/* styles */
var Transfer___vue_styles__ = null
/* scopeId */
var Transfer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Transfer___vue_module_identifier__ = null
var Transfer_Component = Transfer_normalizeComponent(
  Transfer,
  components_Transfer,
  Transfer___vue_template_functional__,
  Transfer___vue_styles__,
  Transfer___vue_scopeId__,
  Transfer___vue_module_identifier__
)

/* harmony default export */ var src_components_Transfer = (Transfer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Wallet.vue







/* harmony default export */ var Wallet = ({
  components: {
    Stat: Stat["a" /* default */],
    Price: formatters["d" /* Price */],
    Transfer: src_components_Transfer
  },
  data: function data() {
    return {
      modal: false
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
    wallet: 'skiliko/wallets/wallet',
    loading: 'skiliko/wallets/isLoading'
  }), {
    currentWallet: function currentWallet() {
      return (this.wallet.availables || [])[0];
    }
  }),
  methods: Object(vuex_esm["b" /* mapActions */])({
    fetch: 'skiliko/wallets/fetch'
  }),
  mounted: function mounted() {
    this.fetch();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73a5c071","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Wallet.vue
var Wallet_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('stat',{attrs:{"title":_vm.$t('wallet.title'),"loading":_vm.loading}},[(_vm.currentWallet)?[(_vm.currentWallet)?_c('price',{attrs:{"value":_vm.currentWallet.amount,"currency":_vm.currentWallet.currency}}):_vm._e(),_vm._v(" "),_c('template',{slot:"actions"},[(_vm.currentWallet.amount)?_c('v-dialog',{attrs:{"lazy":""},model:{value:(_vm.modal),callback:function ($$v) {_vm.modal=$$v},expression:"modal"}},[_c('v-btn',{attrs:{"slot":"activator","primary":"","flat":"","light":""},slot:"activator"},[_vm._v("\n          "+_vm._s(_vm.$t('wallet.transfer'))+"\n        ")]),_vm._v(" "),_c('transfer',{attrs:{"maxAmount":_vm.currentWallet.amount,"currency":_vm.currentWallet.currency},on:{"transferDone":function($event){_vm.modal = false}}})],1):_vm._e()],1)]:_c('span',[_vm._v("-")])],2)}
var Wallet_staticRenderFns = []
var Wallet_esExports = { render: Wallet_render, staticRenderFns: Wallet_staticRenderFns }
/* harmony default export */ var components_Wallet = (Wallet_esExports);
// CONCATENATED MODULE: ./src/components/Wallet.vue
var Wallet_normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var Wallet___vue_template_functional__ = false
/* styles */
var Wallet___vue_styles__ = null
/* scopeId */
var Wallet___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Wallet___vue_module_identifier__ = null
var Wallet_Component = Wallet_normalizeComponent(
  Wallet,
  components_Wallet,
  Wallet___vue_template_functional__,
  Wallet___vue_styles__,
  Wallet___vue_scopeId__,
  Wallet___vue_module_identifier__
)

/* harmony default export */ var src_components_Wallet = (Wallet_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/Transfers.vue






/* harmony default export */ var Transfers = ({
  components: {
    TransferTable: src_components_TransferTable,
    Wallet: src_components_Wallet
  },
  props: {
    page: {
      type: Number,
      default: 1
    }
  },
  methods: {
    onFilterUpdated: function onFilterUpdated(filter) {
      this.$router.push(extends_default()({}, this.$route, {
        query: utils_default["a" /* default */].dataForUrl(filter)
      }));
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-59045edc","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Transfers.vue
var Transfers_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-title',[_vm._v(_vm._s(_vm.$t('pages.transfers.title')))]),_vm._v(" "),_c('v-card-text',[_c('wallet')],1),_vm._v(" "),_c('transfer-table',{attrs:{"page":_vm.page},on:{"filterUpdated":function (data) { return _vm.onFilterUpdated(data); }}})],1)}
var Transfers_staticRenderFns = []
var Transfers_esExports = { render: Transfers_render, staticRenderFns: Transfers_staticRenderFns }
/* harmony default export */ var pages_Transfers = (Transfers_esExports);
// CONCATENATED MODULE: ./src/pages/Transfers.vue
var Transfers_normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var Transfers___vue_template_functional__ = false
/* styles */
var Transfers___vue_styles__ = null
/* scopeId */
var Transfers___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Transfers___vue_module_identifier__ = null
var Transfers_Component = Transfers_normalizeComponent(
  Transfers,
  pages_Transfers,
  Transfers___vue_template_functional__,
  Transfers___vue_styles__,
  Transfers___vue_scopeId__,
  Transfers___vue_module_identifier__
)

/* harmony default export */ var src_pages_Transfers = __webpack_exports__["default"] = (Transfers_Component.exports);


/***/ }),

/***/ 751:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Stat.vue


/* harmony default export */ var Stat = ({
  props: {
    title: {
      type: String,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a245f3c","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Stat.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"text-xs-center"},[_c('v-card-title',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('v-card-text',[(_vm.loading)?_c('v-progress-circular',{staticClass:"primary--text",attrs:{"indeterminate":"","height":2}}):_vm._e(),_vm._v(" "),_vm._t("default")],2),_vm._v(" "),(_vm.$slots.actions)?_c('v-card-row',{attrs:{"actions":""}},[_vm._t("actions")],2):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_Stat = (esExports);
// CONCATENATED MODULE: ./src/components/Stat.vue
function injectStyle (ssrContext) {
  __webpack_require__(767)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4a245f3c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  Stat,
  components_Stat,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_Stat = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 767:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(768);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(747)("a54c80b0", content, true);

/***/ }),

/***/ 768:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(746)(true);
// imports


// module
exports.push([module.i, ".card__title[data-v-4a245f3c]{text-align:center}.card__text[data-v-4a245f3c],.card__title[data-v-4a245f3c]{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.card__text[data-v-4a245f3c]{font-size:3em;padding-top:0;-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex}.progress-circular[data-v-4a245f3c]{position:absolute;top:.25em;right:.25em}", "", {"version":3,"sources":["/home/runner/work/manager/manager/src/components/Stat.vue"],"names":[],"mappings":"AACA,8BACE,iBAAmB,CAIpB,AACD,2DAJE,wBAAyB,AACrB,qBAAsB,AAClB,sBAAwB,CAcjC,AAZD,6BACE,cAAe,AACf,cAAe,AAIf,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,oBAAqB,AACrB,oBAAqB,AACrB,YAAc,CACf,AACD,oCACE,kBAAmB,AACnB,UAAW,AACX,WAAa,CACd","file":"Stat.vue","sourcesContent":["\n.card__title[data-v-4a245f3c] {\n  text-align: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.card__text[data-v-4a245f3c] {\n  font-size: 3em;\n  padding-top: 0;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.progress-circular[data-v-4a245f3c] {\n  position: absolute;\n  top: .25em;\n  right: .25em;\n}\n"],"sourceRoot":""}]);

// exports


/***/ })

});


// WEBPACK FOOTER //
// static/js/16.e89ab3aea5ee83002825.js